import Vue from "vue"; // import "./plugins/vuetify";

import vuetify from "./plugins/vuetify";
import localforage from "./plugins/localforage";
import App from "./App.vue"; // import "./stylus/main.styl";

import store from "./store";
import "@/assets/styles/vue-plotly.css";
Vue.config.productionTip = false;
Vue.config.devtools = process.env.NODE_ENV === "development";
window.App = new Vue({
  store: store,
  // inject store to all children
  vuetify: vuetify,
  render: function render(h) {
    return h(App);
  }
}).$mount("#app"); // window.__VUE_DEVTOOLS_GLOBAL_HOOK__.Vue = window.App.constructor;